<app-hero-title [size]="'medium'">
  <span after class="dark">
    Payment Failed
  </span>
</app-hero-title>
<p class="mt-3 mb-4 pb-3 col-gray-500">Please try again or try different payment method</p>
